import React from 'react';
import cx from 'classnames';

interface Props {
  children?: any;
  className?: string;
  skewAngle?: number;
  style?: any;
}

export default (props) => {
  return (
    <div
      className={cx(props.className, 'd-flex flex-column')}
      style={{
        background: '#fff',
        borderRadius: 12,
        boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1), 0 6px 6px -3px rgba(0, 0, 0, 0.07), 0 2px 2px -1px rgba(0, 0, 0, 0.07)',
        gap: 20,
        padding: 20,
        transform: props.skewAngle ? `rotate(${props.skewAngle}deg)` : 'none',
        ...props.style || {}
      }}
    >
      {props.children}
    </div>
  );
};
